import { HashRouter as Router, Route, Switch } from 'react-router-dom';

import './App.css';
import CapabilityReference from './CapabilityReference';
import DeviceClassReference from './DeviceClassReference';

function App() {
  return (
    <Router /*basename={process.env.PUBLIC_URL}*/>
      <Switch>
        <Route path="/capabilities">
          <CapabilityReference />
        </Route>
        <Route path="/device-classes">
          <DeviceClassReference />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
